(ns bec-core.cljs.views.home
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [cljs.core.async.interop :refer-macros [<p!]]
            [clojure.string :as s]
            [bec-core.cljs.notification :as notification]
            [bec-core.cljs.service-worker :as sw]
            ;; [bec-core.cljs.connection :as connection]
            [bec-cljs-common.utils.css :as css]
            [bec-cljs-common.components.flag-icons :as flag-icons]
            [bec-cljs-common.components.button :as button]
            [bec-cljs-common.components.input :as input]
            [bec-core.cljs.routes :as routes]
            [bec-core.cljs.components.markdown :refer [markdown-editor]]))

(defonce search-variables (r/atom {:venue-id ""
                                   :oche-id ""
                                   :machine-id ""
                                   :machine-type ""}))

(defonce expand-machine-info? (r/atom {}))
(defonce displayed-any? (r/atom nil))

(defn machines []
  (let [machines @(rf/subscribe [:get-in [:shared-state :machines]])]
    (into
     [:div
      {:style {:display "flex"
               :justify-content "center"
               :flex-wrap "wrap"}}
      [:div.message.is-warning
       {:style {:display (if-not @displayed-any? "block" "none")
                :width "20rem"
                :margin "0 0.5rem 1rem 0.5rem"
                :height "fit-content"}}
       [:div.message-header
        {:style {:border-radius "inherit"}}
        "No machines found in search result"]]]
     (for [machine machines]
       (let [uuid (first machine)
             machine-map (:information (second machine))
             display? (and (s/includes? (:venue-id machine-map) (:venue-id @search-variables))
                           (s/includes? (:oche-id machine-map) (:oche-id @search-variables))
                           (s/includes? (:machine-id machine-map) (:machine-id @search-variables))
                           (s/includes? (str (:machine-type machine-map)) (:machine-type @search-variables)))
             expand-info? (get @expand-machine-info? uuid)]
         (reset! displayed-any? display?)
         [:div.message.is-info
          {:key uuid
           :style {:display (if display? "block" "none")
                   :width "20rem"
                   :margin "0 0.5rem 1rem 0.5rem"
                   :height "fit-content"}}
          [:div.message-header
           {:on-click #(swap! expand-machine-info? assoc uuid (not expand-info?))
            :style {:border-radius "inherit"}}
           (or (:machine-id machine-map) "No machine id")
           [:span.icon
            {:style {:transform (if expand-info?
                                  "rotate(180deg)"
                                  "rotate(0deg)")
                     :transition "transform var(--transition-duration, 250ms) ease"}}
            [:i.fas.fa-caret-down]]]
          (into
           [:div.message-body.is-collapsible
            {:class (when-not expand-info? "is-collapsed")
             :style {:max-height "20rem"
                     :overflow "hidden"}}]
           (for [variable machine-map]
             [:div
              (str (name (first variable)) ": " (second variable))]))])))))

(defn machine []
  (into
   [:div]
   (for [variable @search-variables]
     [:div
      (str (name (first variable)) ": " (second variable))])))

(defonce checkbox (r/atom {:checkbox-1 false}))

(defonce search-panel-active? (r/atom {}))

(defn machine-search-panel [& [props]]
  (let [machines @(rf/subscribe [:get-in [:shared-state :machines]])
        machine (first machines)
        uuid (first machine)
        machine-map (:information (second machine))
        expand-info? (get @expand-machine-info? uuid)]
    [:nav.panel.is-accordion
     (merge (when (map? props) (dissoc props :header-props :is-active? :class))
            {:class (str (when (:is-active? props) " is-info ") (:class props))})
     [:header.panel-heading
      (:header-props props)
      [:p "Select venue"]
      [:span.icon
       {:style {:transform (if (:is-active? props)
                             "rotate(180deg)"
                             "rotate(0deg)")
                :transition "transform var(--transition-duration, 250ms) ease"}}
       [:i.fas.fa-caret-down]]]
     [:div.is-collapsible
      {:class (when-not (:is-active? props) " is-collapsed ")}
      [:div.panel-block
       {:style {:border-bottom "none"}}
       [:div.control.has-icons-left
        [:input.input
         {:type "text"
          :placeholder "search"}]
        [:span.icon.is-left
         [:i.fas.fa-search
          {:aria-hidden true}]]]]
      [:div.tabs.is-centered.is-boxed
       {:style {:margin-bottom 0}}
       [:ul
        [:li.is-active
         [:a "All"]]
        [:li
         [:a "Norway"]]
        [:li
         [:a "Australia"]]
        [:li
         [:a "Sweden"]]
        [:li
         [:a "Denmark"]]
        [:li
         [:a "Germany"]]]]
      [:div.panel-body
       {:style {:max-height "50vh"}}
       [:a.panel-block.is-active
        [:span.panel-icon
         [:i.fas.fa-book
          {:aria-hidden true}]]
        "multires.css"]
       [:label.panel-block
        [:input.is-info
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-rounded.is-primary
         {:on-key-up (fn [event]
                       (when (or (= event.key "Enter") (= event.keyCode 13))
                         (swap! checkbox assoc :checkbox-1 (not (:checkbox-1 @checkbox)))))
          :on-change (fn [event]
                       (swap! checkbox assoc :checkbox-1 (not (:checkbox-1 @checkbox))))
          :checked (:checkbox-1 @checkbox)
          :type "checkbox"}]
        [:label
         "remeber me"]]
       [:label.panel-block
        [:div
         {:key uuid
          :style {:display "block"
                  :width "100%"
                  :margin "0"
                  :height "fit-content"}}
         [:div
          {:on-click #(swap! expand-machine-info? assoc uuid (not expand-info?))
           :style {:display "flex"
                   :justify-content "space-between"}}
          (or (:machine-id machine-map) "No machine id")
          [:span.icon
           {:style {:transform (if expand-info?
                                 "rotate(180deg)"
                                 "rotate(0deg)")
                    :transition "transform var(--transition-duration, 250ms) ease"}}
           [:i.fas.fa-caret-down]]]
         (into
          [:ul.is-collapsible
           {:class (when-not expand-info? "is-collapsed")
            :style {:max-height "20rem"
                    :overflow "hidden"
                    :list-style "inside"}}]
          (for [variable machine-map]
            [:li
             {:style {:margin-left "1rem"}}
             (str (name (first variable)) ": " (second variable))]))]]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "radio"
          :name "radio"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-danger.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-warning.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-success.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-link.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "radio"
          :name "radio"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-info.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-danger.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-warning.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-success.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-primary.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"
          :checked true
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-rounded.is-primary
         {:type "checkbox"
          :checked true
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-rounded.is-primary
         {:type "checkbox"
          :disabled true}]
        "remeber me"]]
      [:div.panel-block
       [:button.button.is-link.is-outlined.is-fullwidth
        "Reset all filters"]]]]))

(defn testing-scroll [& [props]]
  (let [scroll-margin-top-supported? @(rf/subscribe [:CSS-supports :scroll-margin-top])
        machines @(rf/subscribe [:get-in [:shared-state :machines]])
        machine (first machines)
        uuid (first machine)
        machine-map (:information (second machine))
        expand-info? (get @expand-machine-info? uuid)]
    [:nav.panel.is-accordion
     (merge (when (map? props) (dissoc props :header-props :is-active? :class))
            {:class (str (when (:is-active? props) " is-info ") (:class props))})
     [:div.panel-heading
      (:header-props props)
      [:p "Select venue"]
      [:span.icon
       {:style {:transform (if (:is-active? props)
                             "rotate(180deg)"
                             "rotate(0deg)")
                :transition "transform var(--transition-duration, 250ms) ease"}}
       [:i.fas.fa-caret-down]]]
     [:div.is-collapsible
      {:class (when-not (:is-active? props) " is-collapsed ")
       :style {:overflow "hidden"}}
      [:div.panel-block
       {:style {:border-bottom "none"}}
       [:div.control.has-icons-left
        [:input.input
         {:type "text"
          :placeholder "search"}]
        [:span.icon.is-left
         [:i.fas.fa-search
          {:aria-hidden true}]]]]
      [:div.tabs.is-centered.is-boxed
       {:style {:margin-bottom 0}}
       [:ul
        [:li.is-active
         [:a "All"]]
        [:li
         [:a "Norway"]]
        [:li
         [:a "Australia"]]
        [:li
         [:a "Sweden"]]
        [:li
         [:a "Denmark"]]
        [:li
         [:a "Germany"]]]]
      [:div.panel-body
       {:style {:max-height "50vh"
                :scroll-snap-type "y mandatory"}}
       [:span#top-label.anchor]
       [:a.panel-block.is-active
        {:href "#bottom-label"}
        [:span.panel-icon
         [:i.fas.fa-book
          {:aria-hidden true}]]
        "multires.css"]
       [:label.panel-block
        [:input.is-info
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-rounded.is-primary
         {:on-key-up (fn [event]
                       (when (or (= event.key "Enter") (= event.keyCode 13))
                         (swap! checkbox assoc :checkbox-1 (not (:checkbox-1 @checkbox)))))
          :on-change (fn [event]
                       (swap! checkbox assoc :checkbox-1 (not (:checkbox-1 @checkbox))))
          :checked (:checkbox-1 @checkbox)
          :type "checkbox"}]
        [:label
         "remeber me"]]
       [:label.panel-block
        [:div
         {:key uuid
          :style {:display "block"
                  :width "100%"
                  :margin "0"
                  :height "fit-content"}}
         [:div
          {:on-click #(swap! expand-machine-info? assoc uuid (not expand-info?))
           :style {:display "flex"
                   :justify-content "space-between"}}
          (or (:machine-id machine-map) "No machine id")
          [:span.icon
           {:style {:transform (if expand-info?
                                 "rotate(180deg)"
                                 "rotate(0deg)")
                    :transition "transform var(--transition-duration, 250ms) ease"}}
           [:i.fas.fa-caret-down]]]
         (into
          [:ul.is-collapsible
           {:class (when-not expand-info? "is-collapsed")
            :style {:max-height "20rem"
                    :overflow "hidden"
                    :list-style "inside"}}]
          (for [variable machine-map]
            [:li
             {:style {:margin-left "1rem"}}
             (str (name (first variable)) ": " (second variable))]))]]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "radio"
          :name "radio"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-danger.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-warning.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-success.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-link.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-info.is-rounded
         {:type "radio"
          :name "radio"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-info.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-danger.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-warning.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-success.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-primary.is-rounded
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch
         {:type "checkbox"
          :checked true
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-rounded.is-primary
         {:type "checkbox"
          :checked true
          :disabled true}]
        "remeber me"]
       [:label.panel-block
        [:input.is-switch.is-rounded.is-primary
         {:type "checkbox"
          :disabled true}]
        "remeber me"]
       [:span#bottom-label.anchor]
       [:label.panel-block
        [:a
         {:href "#top-label"}
         "remeber me"]]]
      [:div.panel-block
       [:button.button.is-link.is-outlined.is-fullwidth
        "Reset all filters"]]]]))

(defn auto-hiccup-test []
  [:section
   [:h1 {:class "title"} ]
   [:p {:class "subtitle"} "Modern CSS framework based on "
    [:a {:href "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox"} "Flexbox"]]
   [:div {:class "field"}
    [:div {:class "control"}
     [:input {:class "input", :type "text", :placeholder "Input"}]]]
   [:div {:class "field"}
    [:div {:class "control"}
     [:input {:class "input is-info is-rounded", :type "text", :placeholder "Input"}]]]
   [:div {:class "field"}
    [:div {:class "control"}
     [:input {:class "input is-dark is-rounded", :type "text", :placeholder "Input"}]]]
   [:div {:class "dropdown is-active is-rounded"}
    [:div {:class "dropdown-trigger"}
     [:button {:class "button", :aria-haspopup true, :aria-controls "dropdown-menu"}
      [:span "Dropdown button"]
      [:span {:class "icon is-small"}
       [:i {:class "fas fa-angle-down", :aria-hidden true}]]]]
    [:div {:class "dropdown-menu", :id "dropdown-menu", :role "menu"}
     [:div {:class "dropdown-content"}
      [:a {:href "#", :class "dropdown-item"} "Dropdown item"]
      [:a {:class "dropdown-item"} "Other dropdown item"]
      [:a {:href "#", :class "dropdown-item is-active"} "Active dropdown item"]
      [:a {:href "#", :class "dropdown-item"} "Other dropdown item"]
      [:hr {:class "dropdown-divider"}]
      [:a {:href "#", :class "dropdown-item"} "With a divider"]]]]
   [:div {:class "dropdown is-up is-active is-rounded"}
    [:div {:class "dropdown-trigger"}
     [:button {:class "button", :aria-haspopup true, :aria-controls "dropdown-menu1"}
      [:span "Dropdown button"]
      [:span {:class "icon is-small"}
       [:i {:class "fas fa-angle-up", :aria-hidden true}]]]]
    [:div {:class "dropdown-menu", :id "dropdown-menu1", :role "menu"}
     [:div {:class "dropdown-content"}
      [:a {:href "#", :class "dropdown-item"} "Dropdown item"]
      [:a {:class "dropdown-item"} "Other dropdown item"]
      [:a {:href "#", :class "dropdown-item is-active"} "Active dropdown item"]
      [:a {:href "#", :class "dropdown-item"} "Other dropdown item"]
      [:hr {:class "dropdown-divider"}]
      [:a {:href "#", :class "dropdown-item"} "With a divider"]]]]
   [:div {:class "field"}
    [:p {:class "control"}
     [:span {:class "select is-rounded"}
      [:select
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]
       [:option "Select dropdown"]]]]
    [:h1 {:class "title is-1"} "Title 1"]
    [:h2 {:class "title is-2"} "Title 2"]
    [:h3 {:class "title is-3"} "Title 3"]
    [:h4 {:class "title is-4"} "Title 4"]
    [:h5 {:class "title is-5"} "Title 5"]
    [:h6 {:class "title is-6"} "Title 6"]
    [:h1 {:class "subtitle is-1"} "Subtitle 1"]
    [:h2 {:class "subtitle is-2"} "Subtitle 2"]
    [:h3 {:class "subtitle is-3"} "Subtitle 3"]
    [:h4 {:class "subtitle is-4"} "Subtitle 4"]
    [:h5 {:class "subtitle is-5"} "Subtitle 5"]
    [:h6 {:class "subtitle is-6"} "Subtitle 6"]
    [:p {:class "title is-1"} "Title 1"]
    [:p {:class "subtitle is-3"} "Subtitle 3"]
    [:p {:class "title is-2"} "Title 2"]
    [:p {:class "subtitle is-4"} "Subtitle 4"]
    [:p {:class "title is-3"} "Title 3"]
    [:p {:class "subtitle is-5"} "Subtitle 5"]
    [:p {:class "title is-1 is-spaced"} "Title 1"]
    [:p {:class "subtitle is-3"} "Subtitle 3"]
    [:p {:class "title is-2 is-spaced"} "Title 2"]
    [:p {:class "subtitle is-4"} "Subtitle 4"]
    [:p {:class "title is-3 is-spaced"} "Title 3"]
    [:p {:class "subtitle is-5"} "Subtitle 5"]
    [:div {:class "file is-info has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-success has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-danger has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-warning has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-primary has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-dark has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-light has-name"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file has-name is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-fullwidth is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-right is-fullwidth is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file has-name is-large is-right is-fullwidth is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:div {:class "file is-link has-name is-large is-right is-fullwidth is-rounded"}
     [:label {:class "file-label"}
      [:input {:class "file-input", :type "file", :name "resume"}]
      [:span {:class "file-cta"}
       [:span {:class "file-icon"}
        [:i {:class "fas fa-upload"}]]
       [:span {:class "file-label"} "Info file…"]]
      [:span {:class "file-name"} "Screen Shot 2017-07-29 at 15.54.25.png"]]]
    [:span {:class "icon is-clickable"}
     [:i {:class "fas fa-upload"}]]
    [:a {:class "icon is-clickable is-large"}
     [:i {:class "fas fa-upload"}]]
    [:div {:class "icon is-clickable"}
     [:i {:class "fas fa-upload"}]]
    [:span {:disabled true, :class "icon is-clickable"}
     [:i {:class "fas fa-upload"}]]
    [:a {:disabled true, :class "icon is-clickable is-large"}
     [:i {:class "fas fa-upload"}]]
    [:div {:disabled true, :class "icon is-clickable"}
     [:i {:class "fas fa-upload"}]]
    [:div {:class "select is-multiple is-light"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-dark"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-danger"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-warning"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-success"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-info"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-link"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "select is-multiple is-primary"}
     [:select {:multiple true, :size "8"}
      [:option {:on-change (fn [] nil)
                :value "Argentina"} "Argentina"]
      [:option {:on-change (fn [] nil)
                :value "Bolivia"} "Bolivia"]
      [:option {:on-change (fn [] nil)
                :value "Brazil"} "Brazil"]
      [:option {:on-change (fn [] nil)
                :value "Chile"} "Chile"]
      [:option {:on-change (fn [] nil)
                :value "Colombia"} "Colombia"]
      [:option {:on-change (fn [] nil)
                :value "Ecuador"} "Ecuador"]
      [:option {:on-change (fn [] nil)
                :value "Guyana"} "Guyana"]
      [:option {:on-change (fn [] nil)
                :value "Paraguay"} "Paraguay"]
      [:option {:on-change (fn [] nil)
                :value "Peru"} "Peru"]
      [:option {:on-change (fn [] nil)
                :value "Suriname"} "Suriname"]
      [:option {:on-change (fn [] nil)
                :value "Uruguay"} "Uruguay"]
      [:option {:on-change (fn [] nil)
                :value "Venezuela"} "Venezuela"]]]
    [:div {:class "buttons"}
     [:button {:class "button is-primary is-rounded is-loading"} "Primary"]
     [:button {:class "button is-primary is-rounded"} "Primary"]
     [:button {:class "button is-primary is-outlined"} "Primary"]
     [:button {:class "button is-primary is-light"} "Primary"]
     [:button {:class "button is-primary"} "Primary"]
     [:button {:class "button is-info"} "Primary"]
     [:button {:class "button is-text"} "Primary"]
     [:button {:class "button is-ghost"} "Primary"]
     [:button {:class "button is-danger is-outlined is-large"} "Primary"]
     [:button {:class "button is-danger is-light"} "Primary"]
     [:button {:class "button is-danger is-small"} "Primary"]
     [:button {:class "button is-danger"} "Primary"]
     [:button {:class "button is-danger is-light"} "Primary"]
     [:button {:class "button is-danger is-dark"} "Primary"]
     [:button {:class "button is-success is-small"} "Primary"]
     [:button {:class "button is-success"} "Primary"]
     [:button {:class "button is-success is-large"} "Primary"]
     [:button {:class "button is-success is-light"} "Primary"]
     [:button {:class "button is-warning"} "Primary"]
     [:button {:class "button is-warning is-light"} "Primary"]
     [:button {:class "button is-dark"} "Primary"]
     [:button {:class "button is-dark is-outlined"} "Primary"]
     [:button {:class "button is-light"} "Primary"]
     [:button {:class "button is-light is-outlined"} "Primary"]
     [:button {:class "button is-link"} "Link"]]]
   [:div {:class "modal "}
    [:div {:class "modal-background"}]
    [:div {:class "modal-card"}
     [:header {:class "modal-card-head"}
      [:p {:class "modal-card-title"} "Modal title"]
      [:button {:class "delete", :aria-label "close"}]]
     [:section {:class "modal-card-body"}  "<!-- Content ... -->" ]
     [:footer {:class "modal-card-foot"}
      [:button {:class "button is-success"} "Save changes"]
      [:button {:class "button"} "Cancel"]]]]
   [:nav {:class "breadcrumb has-arrow-separator", :aria-label "breadcrumbs"}
    [:ul
     [:li
      [:a {:href "#"} "Bulma"]]
     [:li
      [:a {:href "#"} "Documentation"]]
     [:li
      [:a {:href "#"} "Components"]]
     [:li {:class "is-active"}
      [:a {:href "#", :aria-current "page"} "Breadcrumb"]]]]
   [:div {:class "card"}
    [:header {:class "card-header"}
     [:p {:class "card-header-title"} ]
     [:div {:class "card-header-icon", :aria-label "more options"}
      [:span {:class "icon"}
       [:i {:class "fas fa-angle-down", :aria-hidden true}]]]]
    [:div {:class "card-content"}
     [:div {:class "content"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris."
      [:a {:href "#"} "@bulmaio"]". "
      [:a {:href "#"} "#css"]
      [:a {:href "#"} "#responsive"]
      [:br]
      [:time {:date-time "2016-1-1"} "11:09 PM - 1 Jan 2016"]]]
    [:footer {:class "card-footer"}
     [:a {:href "#", :class "card-footer-item"} "Save"]
     [:a {:href "#", :class "card-footer-item"} "Edit"]
     [:a {:href "#", :class "card-footer-item"} "Delete"]]]
   [:div {:class "card"}
    [:header {:class "card-header"}
     [:p {:class "card-header-title"} ]
     [:div {:class "card-header-icon", :aria-label "more options"}
      [:span {:class "icon"}
       [:i {:class "fas fa-angle-down", :aria-hidden true}]]]]
    [:div {:class "card-content is-collapsible"}
     [:div {:class "content"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris."
      [:a {:href "#"} "@bulmaio"]". "
      [:a {:href "#"} "#css"]
      [:a {:href "#"} "#responsive"]
      [:br]
      [:time {:date-time "2016-1-1"} "11:09 PM - 1 Jan 2016"]]]
    [:footer {:class "card-footer"}
     [:a {:href "#", :class "card-footer-item"} "Save"]
     [:a {:href "#", :class "card-footer-item"} "Edit"]
     [:a {:href "#", :class "card-footer-item"} "Delete"]]]
   [:aside {:class "menu"}
    [:p {:class "menu-label"} ]
    [:ul {:class "menu-list"}
     [:li
      [:a "Dashboard"]]
     [:li
      [:a "Customers"]]]
    [:p {:class "menu-label"} ]
    [:ul {:class "menu-list"}
     [:li
      [:a "Team Settings"]]
     [:li
      [:a {:class "is-active"} "Manage Your Team"]
      [:ul
       [:li
        [:a "Members"]]
       [:li
        [:a "Plugins"]]
       [:li
        [:a "Add a member"]]]]
     [:li
      [:a "Invitations"]]
     [:li
      [:a "Cloud Storage Environment Settings"]]
     [:li
      [:a "Authentication"]]]
    [:p {:class "menu-label"} ]
    [:ul {:class "menu-list"}
     [:li
      [:a "Payments"]]
     [:li
      [:a "Transfers"]]
     [:li
      [:a "Balance"]]]]
   [:nav {:class "pagination", :role "navigation", :aria-label "pagination"}
    [:a {:class "pagination-previous"} "Previous"]
    [:a {:class "pagination-next"} "Next page"]
    [:ul {:class "pagination-list"}
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 1"} "1"]]
     [:li
      [:span {:class "pagination-ellipsis"} "…"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 45"} "45"]]
     [:li
      [:a {:class "pagination-link is-current", :aria-label "Page 46", :aria-current "page"} "46"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 47"} "47"]]
     [:li
      [:span {:class "pagination-ellipsis"} "…"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 86"} "86"]]]]
   [:nav {:class "pagination is-rounded", :role "navigation", :aria-label "pagination"}
    [:a {:class "pagination-previous"} "Previous"]
    [:a {:class "pagination-next"} "Next page"]
    [:ul {:class "pagination-list"}
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 1"} "1"]]
     [:li
      [:span {:class "pagination-ellipsis"} "…"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 45"} "45"]]
     [:li
      [:a {:class "pagination-link is-current", :aria-label "Page 46", :aria-current "page"} "46"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 47"} "47"]]
     [:li
      [:span {:class "pagination-ellipsis"} "…"]]
     [:li
      [:a {:class "pagination-link", :aria-label "Goto page 86"} "86"]]]]
   [:nav {:class "panel"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-white"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-white", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-black"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-black", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-light"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-light", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-dark"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-dark", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-info"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-info", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-danger"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-danger", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-warning"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-warning", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-success"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-success", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-link"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-link", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:nav {:class "panel is-primary"}
    [:p {:class "panel-heading"}
     "Repositories"]
    [:div {:class "panel-block"}
     [:p {:class "control has-icons-left"}
      [:input {:class "input is-primary", :type "text", :placeholder "Search"}]
      [:span {:class "icon is-left"}
       [:i {:class "fas fa-search", :aria-hidden true}]]]]
    [:p {:class "panel-tabs"}
     [:a {:class "is-active"} "All"]
     [:a "Public"]
     [:a "Private"]
     [:a "Sources"]
     [:a "Forks"]]
    [:a {:class "panel-block is-active"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"minireset.css"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-book", :aria-hidden true}]]"jgthms.github.io"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]"daniellowtw/infboard"]
    [:a {:class "panel-block"}
     [:span {:class "panel-icon"}
      [:i {:class "fas fa-code-branch", :aria-hidden true}]]]
    [:label {:class "panel-block"}
     [:input {:type "checkbox"}]"remember me"]
    [:div {:class "panel-block"}
     [:button {:class "button is-link is-outlined is-fullwidth"} "Reset all filters"]]]
   [:div {:class "tile is-ancestor"}
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "One"]
      [:p {:class "subtitle"} "Subtitle"]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Two"]
      [:p {:class "subtitle"} "Subtitle"]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Three"]
      [:p {:class "subtitle"} "Subtitle"]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Four"]
      [:p {:class "subtitle"} "Subtitle"]]]]
   [:div {:class "tile is-ancestor"}
    [:div {:class "tile is-vertical is-9"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent"}
       [:div {:class "tile is-child card"}
        [:header {:class "card-header"}
         [:p {:class "card-header-title"} ]
         [:div {:class "card-header-icon", :aria-label "more options"}
          [:span {:class "icon"}
           [:i {:class "fas fa-angle-down", :aria-hidden true}]]]]
        [:div {:class "card-content"}
         [:div {:class "content"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris."
          [:a {:href "#"} "@bulmaio"]". "
          [:a {:href "#"} "#css"]
          [:a {:href "#"} "#responsive"]
          [:br]
          [:time {:date-time "2016-1-1"} "11:09 PM - 1 Jan 2016"]]]
        [:footer {:class "card-footer"}
         [:a {:href "#", :class "card-footer-item"} "Save"]
         [:a {:href "#", :class "card-footer-item"} "Edit"]
         [:a {:href "#", :class "card-footer-item"} "Delete"]]]]
      [:div {:class "tile is-8 is-vertical"}
       [:div {:class "tile"}
        [:div {:class "tile is-parent"}
         [:article {:class "tile is-child box"}
          [:p {:class "title"} "Six"]
          [:p {:class "subtitle"} "Subtitle"]]]
        [:div {:class "tile is-parent"}
         [:article {:class "tile is-child box"}
          [:p {:class "title"} "Seven"]
          [:p {:class "subtitle"} "Subtitle"]]]]
       [:div {:class "tile is-parent"}
        [:article {:class "tile is-child box"}
         [:p {:class "title"} "Eight"]
         [:p {:class "subtitle"} "Subtitle"]]]]]
     [:div {:class "tile"}
      [:div {:class "tile is-8 is-parent"}
       [:article {:class "tile is-child box"}
        [:p {:class "title"} "Nine"]
        [:p {:class "subtitle"} "Subtitle"]
        [:div {:class "content"}
         [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis."]]]]
      [:div {:class "tile is-parent"}
       [:article {:class "tile is-child box"}
        [:p {:class "title"} "Ten"]
        [:p {:class "subtitle"} "Subtitle"]
        [:div {:class "content"}
         [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis."]]]]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:div {:class "content"}
       [:p {:class "title"} "Eleven"]
       [:p {:class "subtitle"} "Subtitle"]
       [:div {:class "content"}
        [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam semper diam at erat pulvinar, at pulvinar felis blandit. Vestibulum volutpat tellus diam, consequat gravida libero rhoncus ut. Morbi maximus, leo sit amet vehicula eleifend, nunc dui porta orci, quis semper odio felis ut quam."]
        [:p "Integer sollicitudin, tortor a mattis commodo, velit urna rhoncus erat, vitae congue lectus dolor consequat libero. Donec leo ligula, maximus et pellentesque sed, gravida a metus. Cras ullamcorper a nunc ac porta. Aliquam ut aliquet lacus, quis faucibus libero. Quisque non semper leo."]]]]]]
   [:div {:class "tile is-ancestor"}
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Twelve"]
      [:p {:class "subtitle"} "Subtitle"]
      [:div {:class "content"}
       [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut."]]]]
    [:div {:class "tile is-parent is-6"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Thirteen"]
      [:p {:class "subtitle"} "Subtitle"]
      [:div {:class "content"}
       [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis."]]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child box"}
      [:p {:class "title"} "Fourteen"]
      [:p {:class "subtitle"} "Subtitle"]
      [:div {:class "content"}
       [:p "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut."]]]]]
   [:progress {:class "progress", :on-change (fn [] nil), :value "15", :max "100"} "15%"]
   [:progress {:class "progress is-primary", :on-change (fn [] nil), :value "15", :max "100"} "15%"]
   [:div {:class "tile is-ancestor"}
    [:div {:class "tile is-vertical is-8"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent is-vertical"}
       [:article {:class "tile is-child notification is-primary"}
        [:p {:class "title"} "Vertical..."]
        [:p {:class "subtitle"} "Top tile"]]
       [:article {:class "tile is-child notification is-warning"}
        [:p {:class "title"} "...tiles"]
        [:p {:class "subtitle"} "Bottom tile"]]]
      [:div {:class "tile is-parent"}
       [:article {:class "tile is-child notification is-info"}
        [:p {:class "title"} "Middle tile"]
        [:p {:class "subtitle"} "With an image"]
        [:figure {:class "image is-4by3"}
         [:img {:src "https://bulma.io/images/placeholders/640x480.png"}]]]]]
     [:div {:class "tile is-parent"}
      [:article {:class "tile is-child notification is-danger"}
       [:p {:class "title"} "Wide tile"]
       [:p {:class "subtitle"} "Aligned with the right tile"]
       [:div {:class "content"}  #_"<!-- Content -->" ]]]]
    [:div {:class "tile is-parent"}
     [:article {:class "tile is-child notification is-success"}
      [:div {:class "content"}
       [:p {:class "title"} "Tall tile"]
       [:p {:class "subtitle"} "With even more content"]
       [:div {:class "content"}  #_"<!-- Content -->" ]]]]]
   [:div {:class "tabs is-centered is-boxed"}
    [:ul
     [:li {:class "is-active"}
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-image", :aria-hidden true}]]
       [:span "Pictures"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-music", :aria-hidden true}]]
       [:span "Music"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-film", :aria-hidden true}]]
       [:span "Videos"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "far fa-file-alt", :aria-hidden true}]]
       [:span "Documents"]]]]]
   [:div {:class "tabs is-toggle is-toggle-rounded is-fullwidth"}
    [:ul
     [:li {:class "is-active"}
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-image"}]]
       [:span "Pictures"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-music"}]]
       [:span "Music"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-film"}]]
       [:span "Videos"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-file-alt"}]]
       [:span "Documents"]]]]]
   [:div {:class "tabs is-centered is-toggle-rounded is-fullwidth"}
    [:ul
     [:li {:class "is-active"}
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-image", :aria-hidden true}]]
       [:span "Pictures"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-music", :aria-hidden true}]]
       [:span "Music"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "fas fa-film", :aria-hidden true}]]
       [:span "Videos"]]]
     [:li
      [:a
       [:span {:class "icon is-small"}
        [:i {:class "far fa-file-alt", :aria-hidden true}]]
       [:span "Documents"]]]]]
   [:div {:class "card"}
    [:header {:class "card-header"}
     [:p {:class "card-header-title"} ]
     [:div {:class "card-header-icon", :aria-label "more options"}
      [:span {:class "icon"}
       [:i {:class "fas fa-angle-down", :aria-hidden true}]]]]
    [:div {:class "card-content"}
     [:div {:class "content"}
      [:table {:class "table"}
       [:thead
        [:tr
         [:th
          [:abbr {:title "Position"} "Pos"]]
         [:th "Team"]
         [:th
          [:abbr {:title "Played"} "Pld"]]
         [:th
          [:abbr {:title "Won"} "W"]]
         [:th
          [:abbr {:title "Drawn"} "D"]]
         [:th
          [:abbr {:title "Lost"} "L"]]
         [:th
          [:abbr {:title "Goals for"} "GF"]]
         [:th
          [:abbr {:title "Goals against"} "GA"]]
         [:th
          [:abbr {:title "Goal difference"} "GD"]]
         [:th
          [:abbr {:title "Points"} "Pts"]]
         [:th "Qualification or relegation"]]]
       [:tfoot
        [:tr
         [:th
          [:abbr {:title "Position"} "Pos"]]
         [:th "Team"]
         [:th
          [:abbr {:title "Played"} "Pld"]]
         [:th
          [:abbr {:title "Won"} "W"]]
         [:th
          [:abbr {:title "Drawn"} "D"]]
         [:th
          [:abbr {:title "Lost"} "L"]]
         [:th
          [:abbr {:title "Goals for"} "GF"]]
         [:th
          [:abbr {:title "Goals against"} "GA"]]
         [:th
          [:abbr {:title "Goal difference"} "GD"]]
         [:th
          [:abbr {:title "Points"} "Pts"]]
         [:th "Qualification or relegation"]]]
       [:tbody
        [:tr
         [:th "1"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Leicester_City_F.C.", :title "Leicester City F.C."} "Leicester City"]
          [:strong "(C)"]]
         [:td "38"]
         [:td "23"]
         [:td "12"]
         [:td "3"]
         [:td "68"]
         [:td "36"]
         [:td "+32"]
         [:td "81"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
        [:tr
         [:th "2"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Arsenal_F.C.", :title "Arsenal F.C."} "Arsenal"]]
         [:td "38"]
         [:td "20"]
         [:td "11"]
         [:td "7"]
         [:td "65"]
         [:td "36"]
         [:td "+29"]
         [:td "71"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
        [:tr
         [:th
          [:button.button
           "hello"]]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Tottenham_Hotspur_F.C.", :title "Tottenham Hotspur F.C."} "Tottenham Hotspur"]]
         [:td "38"]
         [:td "19"]
         [:td "13"]
         [:td "6"]
         [:td "69"]
         [:td "35"]
         [:td "+34"]
         [:td "70"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
        [:tr {:class "is-selected"}
         [:th
          [:button.button
           "hello"]]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Manchester_City_F.C.", :title "Manchester City F.C."} "Manchester City"]]
         [:td "38"]
         [:td "19"]
         [:td "9"]
         [:td "10"]
         [:td "71"]
         [:td "41"]
         [:td "+30"]
         [:td "66"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Play-off_round", :title "2016–17 UEFA Champions League"} "Champions League play-off round"]]]
        [:tr
         [:th "5"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Manchester_United_F.C.", :title "Manchester United F.C."} "Manchester United"]]
         [:td "38"]
         [:td "19"]
         [:td "9"]
         [:td "10"]
         [:td "49"]
         [:td "35"]
         [:td "+14"]
         [:td "66"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Group_stage", :title "2016–17 UEFA Europa League"} "Europa League group stage"]]]
        [:tr
         [:th "6"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Southampton_F.C.", :title "Southampton F.C."} "Southampton"]]
         [:td "38"]
         [:td "18"]
         [:td "9"]
         [:td "11"]
         [:td "59"]
         [:td "41"]
         [:td "+18"]
         [:td "63"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Group_stage", :title "2016–17 UEFA Europa League"} "Europa League group stage"]]]
        [:tr
         [:th "7"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/West_Ham_United_F.C.", :title "West Ham United F.C."} "West Ham United"]]
         [:td "38"]
         [:td "16"]
         [:td "14"]
         [:td "8"]
         [:td "65"]
         [:td "51"]
         [:td "+14"]
         [:td "62"]
         [:td "Qualification for the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Third_qualifying_round", :title "2016–17 UEFA Europa League"} "Europa League third qualifying round"]]]
        [:tr
         [:th "8"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Liverpool_F.C.", :title "Liverpool F.C."} "Liverpool"]]
         [:td "38"]
         [:td "16"]
         [:td "12"]
         [:td "10"]
         [:td "63"]
         [:td "50"]
         [:td "+13"]
         [:td "60"]
         [:td]]
        [:tr
         [:th "9"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Stoke_City_F.C.", :title "Stoke City F.C."} "Stoke City"]]
         [:td "38"]
         [:td "14"]
         [:td "9"]
         [:td "15"]
         [:td "41"]
         [:td "55"]
         [:td "−14"]
         [:td "51"]
         [:td]]
        [:tr
         [:th "10"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Chelsea_F.C.", :title "Chelsea F.C."} "Chelsea"]]
         [:td "38"]
         [:td "12"]
         [:td "14"]
         [:td "12"]
         [:td "59"]
         [:td "53"]
         [:td "+6"]
         [:td "50"]
         [:td]]
        [:tr
         [:th "11"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Everton_F.C.", :title "Everton F.C."} "Everton"]]
         [:td "38"]
         [:td "11"]
         [:td "14"]
         [:td "13"]
         [:td "59"]
         [:td "55"]
         [:td "+4"]
         [:td "47"]
         [:td]]
        [:tr
         [:th "12"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Swansea_City_A.F.C.", :title "Swansea City A.F.C."} "Swansea City"]]
         [:td "38"]
         [:td "12"]
         [:td "11"]
         [:td "15"]
         [:td "42"]
         [:td "52"]
         [:td "−10"]
         [:td "47"]
         [:td]]
        [:tr
         [:th "13"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Watford_F.C.", :title "Watford F.C."} "Watford"]]
         [:td "38"]
         [:td "12"]
         [:td "9"]
         [:td "17"]
         [:td "40"]
         [:td "50"]
         [:td "−10"]
         [:td "45"]
         [:td]]
        [:tr
         [:th "14"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/West_Bromwich_Albion_F.C.", :title "West Bromwich Albion F.C."} "West Bromwich Albion"]]
         [:td "38"]
         [:td "10"]
         [:td "13"]
         [:td "15"]
         [:td "34"]
         [:td "48"]
         [:td "−14"]
         [:td "43"]
         [:td]]
        [:tr
         [:th "15"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Crystal_Palace_F.C.", :title "Crystal Palace F.C."} "Crystal Palace"]]
         [:td "38"]
         [:td "11"]
         [:td "9"]
         [:td "18"]
         [:td "39"]
         [:td "51"]
         [:td "−12"]
         [:td "42"]
         [:td]]
        [:tr
         [:th "16"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/A.F.C._Bournemouth", :title "A.F.C. Bournemouth"} "AFC Bournemouth"]]
         [:td "38"]
         [:td "11"]
         [:td "9"]
         [:td "18"]
         [:td "45"]
         [:td "67"]
         [:td "−22"]
         [:td "42"]
         [:td]]
        [:tr
         [:th "17"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Sunderland_A.F.C.", :title "Sunderland A.F.C."} "Sunderland"]]
         [:td "38"]
         [:td "9"]
         [:td "12"]
         [:td "17"]
         [:td "48"]
         [:td "62"]
         [:td "−14"]
         [:td "39"]
         [:td]]
        [:tr
         [:th "18"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Newcastle_United_F.C.", :title "Newcastle United F.C."} "Newcastle United"]
          [:strong "(R)"]]
         [:td "38"]
         [:td "9"]
         [:td "10"]
         [:td "19"]
         [:td "44"]
         [:td "65"]
         [:td "−21"]
         [:td "37"]
         [:td "Relegation to the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]
        [:tr
         [:th "19"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Norwich_City_F.C.", :title "Norwich City F.C."} "Norwich City"]
          [:strong "(R)"]]
         [:td "38"]
         [:td "9"]
         [:td "7"]
         [:td "22"]
         [:td "39"]
         [:td "67"]
         [:td "−28"]
         [:td "34"]
         [:td "Relegation to the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]
        [:tr
         [:th "20"]
         [:td
          [:a {:href "https://en.wikipedia.org/wiki/Aston_Villa_F.C.", :title "Aston Villa F.C."} "Aston Villa"]
          [:strong "(R)"]]
         [:td "38"]
         [:td "3"]
         [:td "8"]
         [:td "27"]
         [:td "27"]
         [:td "76"]
         [:td "−49"]
         [:td "17"]
         [:td "Relegation to the "
          [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]]]]]
    [:footer {:class "card-footer"}
     [:a {:href "#", :class "card-footer-item"} "Save"]
     [:a {:href "#", :class "card-footer-item"} "Edit"]
     [:a {:href "#", :class "card-footer-item"} "Delete"]]]
   [:table {:style {:display "none"} :class "table"}
    [:thead
     [:tr
      [:th
       [:abbr {:title "Position"} "Pos"]]
      [:th "Team"]
      [:th
       [:abbr {:title "Played"} "Pld"]]
      [:th
       [:abbr {:title "Won"} "W"]]
      [:th
       [:abbr {:title "Drawn"} "D"]]
      [:th
       [:abbr {:title "Lost"} "L"]]
      [:th
       [:abbr {:title "Goals for"} "GF"]]
      [:th
       [:abbr {:title "Goals against"} "GA"]]
      [:th
       [:abbr {:title "Goal difference"} "GD"]]
      [:th
       [:abbr {:title "Points"} "Pts"]]
      [:th "Qualification or relegation"]]]
    [:tfoot
     [:tr
      [:th
       [:abbr {:title "Position"} "Pos"]]
      [:th "Team"]
      [:th
       [:abbr {:title "Played"} "Pld"]]
      [:th
       [:abbr {:title "Won"} "W"]]
      [:th
       [:abbr {:title "Drawn"} "D"]]
      [:th
       [:abbr {:title "Lost"} "L"]]
      [:th
       [:abbr {:title "Goals for"} "GF"]]
      [:th
       [:abbr {:title "Goals against"} "GA"]]
      [:th
       [:abbr {:title "Goal difference"} "GD"]]
      [:th
       [:abbr {:title "Points"} "Pts"]]
      [:th "Qualification or relegation"]]]
    [:tbody
     [:tr
      [:th "1"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Leicester_City_F.C.", :title "Leicester City F.C."} "Leicester City"]
       [:strong "(C)"]]
      [:td "38"]
      [:td "23"]
      [:td "12"]
      [:td "3"]
      [:td "68"]
      [:td "36"]
      [:td "+32"]
      [:td "81"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
     [:tr
      [:th "2"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Arsenal_F.C.", :title "Arsenal F.C."} "Arsenal"]]
      [:td "38"]
      [:td "20"]
      [:td "11"]
      [:td "7"]
      [:td "65"]
      [:td "36"]
      [:td "+29"]
      [:td "71"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
     [:tr
      [:th "3"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Tottenham_Hotspur_F.C.", :title "Tottenham Hotspur F.C."} "Tottenham Hotspur"]]
      [:td "38"]
      [:td "19"]
      [:td "13"]
      [:td "6"]
      [:td "69"]
      [:td "35"]
      [:td "+34"]
      [:td "70"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Group_stage", :title "2016–17 UEFA Champions League"} "Champions League group stage"]]]
     [:tr {:class "is-selected"}
      [:th "4"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Manchester_City_F.C.", :title "Manchester City F.C."} "Manchester City"]]
      [:td "38"]
      [:td "19"]
      [:td "9"]
      [:td "10"]
      [:td "71"]
      [:td "41"]
      [:td "+30"]
      [:td "66"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Champions_League#Play-off_round", :title "2016–17 UEFA Champions League"} "Champions League play-off round"]]]
     [:tr
      [:th "5"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Manchester_United_F.C.", :title "Manchester United F.C."} "Manchester United"]]
      [:td "38"]
      [:td "19"]
      [:td "9"]
      [:td "10"]
      [:td "49"]
      [:td "35"]
      [:td "+14"]
      [:td "66"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Group_stage", :title "2016–17 UEFA Europa League"} "Europa League group stage"]]]
     [:tr
      [:th "6"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Southampton_F.C.", :title "Southampton F.C."} "Southampton"]]
      [:td "38"]
      [:td "18"]
      [:td "9"]
      [:td "11"]
      [:td "59"]
      [:td "41"]
      [:td "+18"]
      [:td "63"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Group_stage", :title "2016–17 UEFA Europa League"} "Europa League group stage"]]]
     [:tr
      [:th "7"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/West_Ham_United_F.C.", :title "West Ham United F.C."} "West Ham United"]]
      [:td "38"]
      [:td "16"]
      [:td "14"]
      [:td "8"]
      [:td "65"]
      [:td "51"]
      [:td "+14"]
      [:td "62"]
      [:td "Qualification for the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_UEFA_Europa_League#Third_qualifying_round", :title "2016–17 UEFA Europa League"} "Europa League third qualifying round"]]]
     [:tr
      [:th "8"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Liverpool_F.C.", :title "Liverpool F.C."} "Liverpool"]]
      [:td "38"]
      [:td "16"]
      [:td "12"]
      [:td "10"]
      [:td "63"]
      [:td "50"]
      [:td "+13"]
      [:td "60"]
      [:td]]
     [:tr
      [:th "9"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Stoke_City_F.C.", :title "Stoke City F.C."} "Stoke City"]]
      [:td "38"]
      [:td "14"]
      [:td "9"]
      [:td "15"]
      [:td "41"]
      [:td "55"]
      [:td "−14"]
      [:td "51"]
      [:td]]
     [:tr
      [:th "10"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Chelsea_F.C.", :title "Chelsea F.C."} "Chelsea"]]
      [:td "38"]
      [:td "12"]
      [:td "14"]
      [:td "12"]
      [:td "59"]
      [:td "53"]
      [:td "+6"]
      [:td "50"]
      [:td]]
     [:tr
      [:th "11"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Everton_F.C.", :title "Everton F.C."} "Everton"]]
      [:td "38"]
      [:td "11"]
      [:td "14"]
      [:td "13"]
      [:td "59"]
      [:td "55"]
      [:td "+4"]
      [:td "47"]
      [:td]]
     [:tr
      [:th "12"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Swansea_City_A.F.C.", :title "Swansea City A.F.C."} "Swansea City"]]
      [:td "38"]
      [:td "12"]
      [:td "11"]
      [:td "15"]
      [:td "42"]
      [:td "52"]
      [:td "−10"]
      [:td "47"]
      [:td]]
     [:tr
      [:th "13"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Watford_F.C.", :title "Watford F.C."} "Watford"]]
      [:td "38"]
      [:td "12"]
      [:td "9"]
      [:td "17"]
      [:td "40"]
      [:td "50"]
      [:td "−10"]
      [:td "45"]
      [:td]]
     [:tr
      [:th "14"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/West_Bromwich_Albion_F.C.", :title "West Bromwich Albion F.C."} "West Bromwich Albion"]]
      [:td "38"]
      [:td "10"]
      [:td "13"]
      [:td "15"]
      [:td "34"]
      [:td "48"]
      [:td "−14"]
      [:td "43"]
      [:td]]
     [:tr
      [:th "15"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Crystal_Palace_F.C.", :title "Crystal Palace F.C."} "Crystal Palace"]]
      [:td "38"]
      [:td "11"]
      [:td "9"]
      [:td "18"]
      [:td "39"]
      [:td "51"]
      [:td "−12"]
      [:td "42"]
      [:td]]
     [:tr
      [:th "16"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/A.F.C._Bournemouth", :title "A.F.C. Bournemouth"} "AFC Bournemouth"]]
      [:td "38"]
      [:td "11"]
      [:td "9"]
      [:td "18"]
      [:td "45"]
      [:td "67"]
      [:td "−22"]
      [:td "42"]
      [:td]]
     [:tr
      [:th "17"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Sunderland_A.F.C.", :title "Sunderland A.F.C."} "Sunderland"]]
      [:td "38"]
      [:td "9"]
      [:td "12"]
      [:td "17"]
      [:td "48"]
      [:td "62"]
      [:td "−14"]
      [:td "39"]
      [:td]]
     [:tr
      [:th "18"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Newcastle_United_F.C.", :title "Newcastle United F.C."} "Newcastle United"]
       [:strong "(R)"]]
      [:td "38"]
      [:td "9"]
      [:td "10"]
      [:td "19"]
      [:td "44"]
      [:td "65"]
      [:td "−21"]
      [:td "37"]
      [:td "Relegation to the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]
     [:tr
      [:th "19"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Norwich_City_F.C.", :title "Norwich City F.C."} "Norwich City"]
       [:strong "(R)"]]
      [:td "38"]
      [:td "9"]
      [:td "7"]
      [:td "22"]
      [:td "39"]
      [:td "67"]
      [:td "−28"]
      [:td "34"]
      [:td "Relegation to the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]
     [:tr
      [:th "20"]
      [:td
       [:a {:href "https://en.wikipedia.org/wiki/Aston_Villa_F.C.", :title "Aston Villa F.C."} "Aston Villa"]
       [:strong "(R)"]]
      [:td "38"]
      [:td "3"]
      [:td "8"]
      [:td "27"]
      [:td "27"]
      [:td "76"]
      [:td "−49"]
      [:td "17"]
      [:td "Relegation to the "
       [:a {:href "https://en.wikipedia.org/wiki/2016%E2%80%9317_Football_League_Championship", :title "2016–17 Football League Championship"} "Football League Championship"]]]]]
   [:span {:class "icon-text"}
    [:span {:class "icon"}
     [:i {:class "fas fa-train"}]]
    [:span "Paris"]
    [:span {:class "icon"}
     [:i {:class "fas fa-arrow-right"}]]
    [:span "Budapest"]
    [:span {:class "icon"}
     [:i {:class "fas fa-arrow-right"}]]
    [:span "Bucharest"]
    [:span {:class "icon"}
     [:i {:class "fas fa-arrow-right"}]]
    [:span "Istanbul"]
    [:span {:class "icon"}
     [:i {:class "fas fa-flag-checkered"}]]
    ]
   [:div {:class "block"}
    [:span {:class "tag is-success"} "Hello World"
     [:button {:class "delete is-small"}]]]
   [:div {:class "notification is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-white"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-danger"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-warning"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-success"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-info"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-link"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-primary"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-danger is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-warning is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-success is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-info is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-link is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-primary is-light"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-danger is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-warning is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-success is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-info is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-link is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:div {:class "notification is-primary is-dark"}
    [:button {:class "delete"}]"Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem ipsum dolor sit amet, consectetur adipiscing elit"]
   [:article {:class "message is-light"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-dark"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-info"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-link"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-danger"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-warning"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-success"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:article {:class "message is-primary"}
    [:div {:class "message-header"}
     [:button {:class "delete"}]]
    [:div {:class "message-body"} "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem."]]
   [:div {:class "content"}
    [:h1 "Hello World"]
    [:p "Lorem ipsum"
     [:sup
      [:a "
     [1]"]]" dolor sit amet, consectetur adipiscing elit. Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque. Sub"
     [:sub "script"]" works as well!"]
    [:h2 "Second level"]
    [:p "Curabitur accumsan turpis pharetra "
     [:strong "augue tincidunt"]" blandit. Quisque condimentum maximus mi, sit amet commodo arcu rutrum id. Proin pretium urna vel cursus venenatis. Suspendisse potenti. Etiam mattis sem rhoncus lacus dapibus facilisis. Donec at dignissim dui. Ut et neque nisl."]
    [:ul
     [:li "In fermentum leo eu lectus mollis, quis dictum mi aliquet."]
     [:li "Morbi eu nulla lobortis, lobortis est in, fringilla felis."]
     [:li "Aliquam nec felis in sapien venenatis viverra fermentum nec lectus."]
     [:li "Ut non enim metus."]]
    [:h3 "Third level"]
    [:p "Quisque ante lacus, malesuada ac auctor vitae, congue "
     [:a {:href "#"} "non ante"]". Phasellus lacus ex, semper ac tortor nec, fringilla condimentum orci. Fusce eu rutrum tellus."]
    [:ol
     [:li "Donec blandit a lorem id convallis."]
     [:li "Cras gravida arcu at diam gravida gravida."]
     [:li "Integer in volutpat libero."]
     [:li "Donec a diam tellus."]
     [:li "Aenean nec tortor orci."]
     [:li "Quisque aliquam cursus urna, non bibendum massa viverra eget."]
     [:li "Vivamus maximus ultricies pulvinar."]]
    [:blockquote "Ut venenatis, nisl scelerisque sollicitudin fermentum, quam libero hendrerit ipsum, ut blandit est tellus sit amet turpis."]
    [:p "Quisque at semper enim, eu hendrerit odio. Etiam auctor nisl et "
     [:em "justo sodales"]" elementum. Maecenas ultrices lacus quis neque consectetur, et lobortis nisi molestie."]
    [:p "Sed sagittis enim ac tortor maximus rutrum. Nulla facilisi. Donec mattis vulputate risus in luctus. Maecenas vestibulum interdum commodo."]
    [:dl
     [:dt "Web"]
     [:dd "The part of the Internet that contains websites and web pages"]
     [:dt "HTML"]
     [:dd "A markup language for creating web pages"]
     [:dt "CSS"]
     [:dd "A technology to make HTML look better"]]
    [:p "Suspendisse egestas sapien non felis placerat elementum. Morbi tortor nisl, suscipit sed mi sit amet, mollis malesuada nulla. Nulla facilisi. Nullam ac erat ante."]
    [:h4 "Fourth level"]
    [:p "Nulla efficitur eleifend nisi, sit amet bibendum sapien fringilla ac. Mauris euismod metus a tellus laoreet, at elementum ex efficitur."]
    [:pre "<!DOCTYPE html>\n<html>\n  <head>\n    <title>Hello World</title>\n  </head>\n  <body>\n    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec viverra nec nulla vitae mollis.</p>\n  </body>\n</html>"]
    [:p "Maecenas eleifend sollicitudin dui, faucibus sollicitudin augue cursus non. Ut finibus eleifend arcu ut vehicula. Mauris eu est maximus est porta condimentum in eu justo. Nulla id iaculis sapien."]
    [:table
     [:thead
      [:tr
       [:th "One"]
       [:th "Two"]]]
     [:tbody
      [:tr
       [:td "Three"]
       [:td "Four"]]
      [:tr
       [:td "Five"]
       [:td "Six"]]
      [:tr
       [:td "Seven"]
       [:td "Eight"]]
      [:tr
       [:td "Nine"]
       [:td "Ten"]]
      [:tr
       [:td "Eleven"]
       [:td "Twelve"]]]]
    [:p "Phasellus porttitor enim id metus volutpat ultricies. Ut nisi nunc, blandit sed dapibus at, vestibulum in felis. Etiam iaculis lorem ac nibh bibendum rhoncus. Nam interdum efficitur ligula sit amet ullamcorper. Etiam tristique, leo vitae porta faucibus, mi lacus laoreet metus, at cursus leo est vel tellus. Sed ac posuere est. Nunc ultricies nunc neque, vitae ultricies ex sodales quis. Aliquam eu nibh in libero accumsan pulvinar. Nullam nec nisl placerat, pretium metus vel, euismod ipsum. Proin tempor cursus nisl vel condimentum. Nam pharetra varius metus non pellentesque."]
    [:h5 "Fifth level"]
    [:p "Aliquam sagittis rhoncus vulputate. Cras non luctus sem, sed tincidunt ligula. Vestibulum at nunc elit. Praesent aliquet ligula mi, in luctus elit volutpat porta. Phasellus molestie diam vel nisi sodales, a eleifend augue laoreet. Sed nec eleifend justo. Nam et sollicitudin odio."]
    [:figure
     [:img {:src "https://bulma.io/images/placeholders/256x256.png"}]
     [:img {:src "https://bulma.io/images/placeholders/256x256.png"}]
     [:figcaption "Figure 1: Some beautiful placeholders"]]
    [:h6 "Sixth level"]
    [:p "Cras in nibh lacinia, venenatis nisi et, auctor urna. Donec pulvinar lacus sed diam dignissim, ut eleifend eros accumsan. Phasellus non tortor eros. Ut sed rutrum lacus. Etiam purus nunc, scelerisque quis enim vitae, malesuada ultrices turpis. Nunc vitae maximus purus, nec consectetur dui. Suspendisse euismod, elit vel rutrum commodo, ipsum tortor maximus dui, sed varius sapien odio vitae est. Etiam at cursus metus."]]
   [:form {:class "box"}
    [:div {:class "field"}
     [:label {:class "label"} "Email"]
     [:div {:class "control"}
      [:input {:class "input", :type "email", :placeholder "e.g. alex@example.com"}]]]
    [:div {:class "field"}
     [:label {:class "label"} "Password"]
     [:div {:class "control"}
      [:input {:class "input", :type "password", :placeholder "********"}]]]
    [:button {:class "button is-primary"} "Sign in"]]
   [:div {:class "box"}
    [:article {:class "media"}
     [:div {:class "media-left"}
      [:figure {:class "image is-4x"}
       [:img {:src "https://bulma.io/images/placeholders/128x128.png", :alt "Image"}]]]
     [:div {:class "media-content"}
      [:div {:class "content"}
       [:p
        [:strong "John Smith"]
        [:small "@johnsmith"]
        [:small "31m"]
        [:br]"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis."]]
      [:nav {:class "level is-mobile"}
       [:div {:class "level-left"}
        [:a {:class "level-item", :aria-label "reply"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-reply", :aria-hidden true}]]]
        [:a {:class "level-item", :aria-label "retweet"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-retweet", :aria-hidden true}]]]
        [:a {:class "level-item", :aria-label "like"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-heart", :aria-hidden true}]]]]]]]]
   [:div {:class "box"}
    [:article {:class "media"}
     [:div {:class "media-left"}
      [:figure {:class "image is-4x"}
       [:img {:src "https://bulma.io/images/placeholders/128x128.png", :alt "Image"}]]]
     [:div {:class "media-content"}
      [:div {:class "content"}
       [:p.text-overflow
        [:strong "John Smith"]
        [:small "@johnsmith"]
        [:small "31m"]]]
      [:nav {:class "level is-mobile"}
       [:div {:class "level-left"}
        [:a {:class "level-item", :aria-label "reply"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-reply", :aria-hidden true}]]]
        [:a {:class "level-item", :aria-label "retweet"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-retweet", :aria-hidden true}]]]
        [:a {:class "level-item", :aria-label "like"}
         [:span {:class "icon is-small"}
          [:i {:class "fas fa-heart", :aria-hidden true}]]]]]]]
    [:article.media
     [:p
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis."]]]
   [:a {:class "box"}
    [:div {:class "media-left"}
     [:figure {:class "image is-4x"}
      [:img {:src "https://bulma.io/images/placeholders/128x128.png", :alt "Image"}]]]]
   [:a {:class "box"}
    [:figure {:class "image is-4x"}
     [:img {:src "https://bulma.io/images/placeholders/128x128.png", :alt "Image"}]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "From"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:p {:class "control is-expanded has-icons-left"}
       [:input {:class "input", :type "text", :placeholder "Name"}]
       [:span {:class "icon is-small is-left"}
        [:i {:class "fas fa-user"}]]]]
     [:div {:class "field"}
      [:p {:class "control is-expanded has-icons-left has-icons-right"}
       [:input {:class "input is-success", :type "email", :placeholder "Email", :on-change (fn [] nil), :value
                "alex@smith
       .com"}]
       [:span {:class "icon is-small is-left"}
        [:i {:class "fas fa-envelope"}]]
       [:span {:class "icon is-small is-right"}
        [:i {:class "fas fa-check"}]]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label"}]
    [:div {:class "field-body"}
     [:div {:class "field is-expanded"}
      [:div {:class "field has-addons"}
       [:p {:class "control"}
        [:a {:class "button is-static"} "+44"]]
       [:p {:class "control is-expanded"}
        [:input {:class "input", :type "tel", :placeholder "Your phone number"}]]]
      [:p {:class "help"} "Do not enter the first zero"]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Department"]]
    [:div {:class "field-body"}
     [:div {:class "field is-narrow"}
      [:div {:class "control"}
       [:div {:class "select is-fullwidth"}
        [:select
         [:option "Business development"]
         [:option "Marketing"]
         [:option "Sales"]]]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label"}
     [:label {:class "label"} "Already a member?"]]
    [:div {:class "field-body"}
     [:div {:class "field is-narrow"}
      [:div {:class "control"}
       [:label {:class "radio"}
        [:input {:type "radio", :name "member"}]]
       [:label {:class "radio"}
        [:input {:type "radio", :name "member"}]]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Subject"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:input {:class "input is-danger is-small is-rounded", :type "text", :placeholder "e.g. Partnership opportunity"}]]
      [:p {:class "help is-danger"} "This field is required"]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Question"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:textarea {:class "textarea is-small", :placeholder "Explain how we can help you"}]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Subject"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:input {:class "input is-danger is-rounded", :type "text", :placeholder "e.g. Partnership opportunity"}]]
      [:p {:class "help is-danger"} "This field is required"]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Question"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:textarea {:class "textarea", :placeholder "Explain how we can help you"}]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Subject"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:input {:class "input is-danger is-large is-rounded", :type "text", :placeholder "e.g. Partnership opportunity"}]]
      [:p {:class "help is-danger"} "This field is required"]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label is-normal"}
     [:label {:class "label"} "Question"]]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:textarea {:class "textarea is-large", :placeholder "Explain how we can help you"}]]]]]
   [:div {:class "field is-horizontal"}
    [:div {:class "field-label"}  #_"<!-- Left empty for spacing -->" ]
    [:div {:class "field-body"}
     [:div {:class "field"}
      [:div {:class "control"}
       [:button {:class "button is-primary"} "Send message"]]]]]
   [:nav {:class "level"}  #_"<!-- Left side -->"
    [:div {:class "level-left"}
     [:div {:class "level-item"}
      [:p {:class "subtitle is-5"}
       [:strong "123"]" posts"]]
     [:div {:class "level-item"}
      [:div {:class "field has-addons"}
       [:p {:class "control"}
        [:input {:class "input", :type "text", :placeholder "Find a post"}]]
       [:p {:class "control"}
        [:button {:class "button"} ]]]]] #_"<!-- Right side -->"
    [:div {:class "level-right"}
     [:p {:class "level-item"}
      [:strong "All"]]
     [:p {:class "level-item"}
      [:a "Published"]]
     [:p {:class "level-item"}
      [:a "Drafts"]]
     [:p {:class "level-item"}
      [:a "Deleted"]]
     [:p {:class "level-item"}
      [:a {:class "button is-link"} "New"]]]]
   [:article {:class "media"}
    [:figure {:class "media-left"}
     [:p {:class "image is-4x"}
      [:img {:src "https://bulma.io/images/placeholders/128x128.png"}]]]
    [:div {:class "media-content"}
     [:div {:class "content"}
      [:p
       [:strong "Barbara Middleton"]
       [:br]"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis porta eros lacus, nec ultricies elit blandit non. Suspendisse pellentesque mauris sit amet dolor blandit rutrum. Nunc in tempus turpis."
       [:br]
       [:small
        [:a "Like"]" · "
        [:a "Reply"]" · 3 hrs"]]]
     [:article {:class "media"}
      [:figure {:class "media-left"}
       [:p {:class "image is-3x"}
        [:img {:src "https://bulma.io/images/placeholders/96x96.png"}]]]
      [:div {:class "media-content"}
       [:div {:class "content"}
        [:p
         [:strong "Sean Brown"]
         [:br]"Donec sollicitudin urna eget eros malesuada sagittis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam blandit nisl a nulla sagittis, a lobortis leo feugiat."
         [:br]
         [:small
          [:a "Like"]" · "
          [:a "Reply"]" · 2 hrs"]]]
       [:article {:class "media"}
        [:figure {:class "media-left"}
         [:p {:class "image is-3x"}
          [:img {:src "https://bulma.io/images/placeholders/96x96.png"}]]]
        [:div {:class "media-content"}
         [:div {:class "content"}
          [:p
           [:strong "Sean Brown"]
           [:br]"Donec sollicitudin urna eget eros malesuada sagittis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam blandit nisl a nulla sagittis, a lobortis leo feugiat."
           [:br]
           [:small
            [:a "Like"]" · "
            [:a "Reply"]" · 2 hrs"]]]
         [:article {:class "media"} "Vivamus quis semper metus, non tincidunt dolor. Vivamus in mi eu lorem cursus ullamcorper sit amet nec massa."]
         [:article {:class "media"}
          [:figure {:class "media-left"}
           [:p {:class "image is-3x"}
            [:img {:src "https://bulma.io/images/placeholders/96x96.png"}]]]
          [:div {:class "media-content"}
           [:div {:class "content"}
            [:p
             [:strong "Sean Brown"]
             [:br]"Donec sollicitudin urna eget eros malesuada sagittis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam blandit nisl a nulla sagittis, a lobortis leo feugiat."
             [:br]
             [:small
              [:a "Like"]" · "
              [:a "Reply"]" · 2 hrs"]]]
           [:article {:class "media"} "Vivamus quis semper metus, non tincidunt dolor. Vivamus in mi eu lorem cursus ullamcorper sit amet nec massa."]
           [:article {:class "media"} "Morbi vitae diam et purus tincidunt porttitor vel vitae augue. Praesent malesuada metus sed pharetra euismod. Cras tellus odio, tincidunt iaculis diam non, porta aliquet tortor."]]]]]
       [:article {:class "media"} "Morbi vitae diam et purus tincidunt porttitor vel vitae augue. Praesent malesuada metus sed pharetra euismod. Cras tellus odio, tincidunt iaculis diam non, porta aliquet tortor."]]]
     [:article {:class "media"}
      [:figure {:class "media-left"}
       [:p {:class "image is-3x"}
        [:img {:src "https://bulma.io/images/placeholders/96x96.png"}]]]
      [:div {:class "media-content"}
       [:div {:class "content"}
        [:p
         [:strong "Kayli Eunice "]
         [:br]"Sed convallis scelerisque mauris, non pulvinar nunc mattis vel. Maecenas varius felis sit amet magna vestibulum euismod malesuada cursus libero. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Phasellus lacinia non nisl id feugiat."
         [:br]
         [:small
          [:a "Like"]" · "
          [:a "Reply"]" · 2 hrs"]]]]]]]
   [:article {:class "media"}
    [:figure {:class "media-left"}
     [:p {:class "image is-4x"}
      [:img {:src "https://bulma.io/images/placeholders/128x128.png"}]]]
    [:div {:class "media-content"}
     [:div {:class "field"}
      [:p {:class "control"}
       [:textarea {:class "textarea", :placeholder "Add a comment..."}]]]
     [:div {:class "field"}
      [:p {:class "control"}
       [:button {:class "button"} "Post comment"]]]]]])

(defonce dummy-value-hue (r/atom {}))
(defonce dummy-value-saturation (r/atom {}))
(defonce dummy-value-lightness (r/atom {}))

(defn tiles []
  [:div
   [:div.tile.is-ancestor
    [:div {:class "tile is-vertical is-6"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent is-vertical"}
       [:p.title
        "Primary color"]
       [:article {:class "tile is-child box"}
        [:div.box
         [:p.subtitle (str "Hue: " (or (:primary @dummy-value-hue) 0) "°")]
         [:input.slider.hue.is-primary
          {:type "range"
           :min "0"
           :max "360"
           :step "1"
           :value (or (:primary @dummy-value-hue) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-hue assoc :primary value)
                          (css/set-global-property "--primary-brand-color-hue" value)))}]]
        [:div.box
         [:p.subtitle (str "Saturation: " (or (:primary @dummy-value-saturation) 0) "%")]
         [:input.slider.is-primary
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:primary @dummy-value-saturation) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-saturation assoc :primary value)
                          (css/set-global-property "--primary-brand-color-saturation" (str value "%"))))}]]
        [:div.box
         [:p.subtitle (str "Lightness: " (or (:primary @dummy-value-lightness) 0) "%")]
         [:input.slider.is-primary
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:primary @dummy-value-lightness) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-lightness assoc :primary value)
                          (css/set-global-property "--primary-brand-color-lightness" (str value "%"))))}]]]]]]
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Blue sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-link"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:blue @dummy-value-saturation) 0) "%")]
        [:input.slider.is-link
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:blue @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :blue value)
                         (css/set-global-property "--blue-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:blue @dummy-value-lightness) 0) "%")]
        [:input.slider.is-link
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:blue @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :blue value)
                         (css/set-global-property "--blue-lightness" (str value "%"))))}]]]]]]
   [:div.tile.is-ancestor
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Red sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-danger"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:red @dummy-value-saturation) 0) "%")]
        [:input.slider.is-danger
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:red @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :red value)
                         (css/set-global-property "--red-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:red @dummy-value-lightness) 0) "%")]
        [:input.slider.is-danger
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:red @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :red value)
                         (css/set-global-property "--red-lightness" (str value "%"))))}]]]]]
    [:div {:class "tile is-vertical is-6"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent is-vertical"}
       [:p.title
        "Cyan color"]
       [:article {:class "tile is-child box"}
        [:article {:class "message is-info"}
         [:div {:class "message-header"}
          [:button {:class "delete"}]]
         [:div {:class "message-body"}
          "Lorem ipsum dolor sit amet."]]
        [:div.box
         [:p.subtitle (str "Saturation: " (or (:cyan @dummy-value-saturation) 0) "%")]
         [:input.slider.is-info
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:cyan @dummy-value-saturation) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-saturation assoc :cyan value)
                          (css/set-global-property "--cyan-saturation" (str value "%"))))}]]
        [:div.box
         [:p.subtitle (str "Lightness: " (or (:cyan @dummy-value-lightness) 0) "%")]
         [:input.slider.is-info
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:cyan @dummy-value-lightness) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-lightness assoc :cyan value)
                          (css/set-global-property "--cyan-lightness" (str value "%"))))}]]]]]]]
   [:div.tile.is-ancestor
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Yellow sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-warning"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:yellow @dummy-value-saturation) 0) "%")]
        [:input.slider.is-warning
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:yellow @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :yellow value)
                         (css/set-global-property "--yellow-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:yellow @dummy-value-lightness) 0) "%")]
        [:input.slider.is-warning
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:yellow @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :yellow value)
                         (css/set-global-property "--yellow-lightness" (str value "%"))))}]]]]]
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Green sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-success"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:green @dummy-value-saturation) 0) "%")]
        [:input.slider.is-success
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:green @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :green value)
                         (css/set-global-property "--green-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:green @dummy-value-lightness) 0) "%")]
        [:input.slider.is-success
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:green @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :green value)
                         (css/set-global-property "--green-lightness" (str value "%"))))}]]]]]]
   [:div.tile.is-ancestor
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Scheme main color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:scheme-main @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:scheme-main @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:scheme-main @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-main @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:scheme-main @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-main @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-lightness" (str value "%"))))}]]]]
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Scheme invert color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:scheme-invert @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:scheme-invert @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:scheme-invert @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-invert @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:scheme-invert @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-invert @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-lightness" (str value "%"))))}]]]]]
   [:div.tile.is-ancestor
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Text color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:text-color @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:text-color @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :text-color value)
                        (css/set-global-property "--text-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:text-color @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:text-color @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :text-color value)
                        (css/set-global-property "--text-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:text-color @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:text-color @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :text-color value)
                        (css/set-global-property "--text-lightness" (str value "%"))))}]]]]]])

(defn hero []
  (let [user-name (:name @(rf/subscribe [:login]))]
    [:section.hero.is-primary
     [:div.hero-body
      [:div.container
       [:p.title (str "Welcome " user-name)]
       #_[:p "23 notifications recieved since last you logged in"]]]]))

(defn view []
  (let [notification-permission? @(rf/subscribe [:notification-permission?])
        notification-persistent? @(rf/subscribe [:notification-persistent?])
        app-installable? @(rf/subscribe [:app-installable?])
        display-mode @(rf/subscribe [:display-mode])
        ;; connection-information @(rf/subscribe [:connection-information])
        user-selected-theme @(rf/subscribe [:theme :user-selected])
        system-theme @(rf/subscribe [:theme :system])
        theme @(rf/subscribe [:theme])]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [hero]
     [:div.container.is-fluid
      {:style {:margin-bottom "1rem"}}
      #_[markdown-editor]]
     #_[:div.container.is-fluid
        [:div.buttons
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Shared state test"]
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:select-view :selection])}
          "Show selection"]
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:select-view :countries])}
          "Show countries"]
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:select-view :cities])}
          "Show cities"]
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:select-view :venues])}
          "Show venues"]
         [:button.button.fade-in
          {:on-click #(rf/dispatch [:select-view :machines])}
          "Show machines"]
         [:button.button
          {:on-click #(rf/dispatch [:select-view :dashboard])}
          "Go to dashboard"]
         [:button.button
          {:on-click #(rf/dispatch [:select-view :login])}
          "Show login"]
         [:button.button
          {:on-click #(.back @routes/history)}
          "back"]
         [:button.button
          {:on-click #(.forward @routes/history)}
          "Forward"]
         [:button.button
          {:on-click #(do
                        (println (js-keys @routes/history))
                        (println (js-in "history" js/window))
                        (println (js-in "pushState" js/window.history))
                        (println (.-origin js/window.location))
                        (println (.-host js/window.location))
                        (println (.-hostname js/window.location))
                        (println (.-protocol js/window.location))
                        (println (.-pathname js/window.location))
                        (println (.-search js/window.location))
                        (println (.-hash js/window.location))
                        (println (.toString js/window.location))
                        (println (.-length @routes/history))
                        (println (cljs.reader/read-string (.-state @routes/history))))}
          "State"]
         [:button.button
          {:on-click #(println @(rf/subscribe [:CSS-supports]))}
          "css supports"]]
        [input/radio
         {:name "shako"
          :value 1}]
        [input/radio
         {:name "shako"
          :value 2}]
        [input/radio
         {:name "shako"
          :value 3}]
        [input/checkbox
         {:id "shako-1"}
         "Ok"]
        [input/switch
         {:id "shako-2"}
         "Nei"]
        [:section.section
         {:style {:padding-left 0
                  :padding-right 0}}
         [machine-search-panel
          {:is-active? (:venue-id @search-panel-active?)
           :header-props {:on-click #(swap! search-panel-active? assoc :venue-id (not (:venue-id @search-panel-active?)))}}]
         [machine-search-panel
          {:is-active? (:oche-id @search-panel-active?)
           :header-props {:on-click #(swap! search-panel-active? assoc :oche-id (not (:oche-id @search-panel-active?)))}}]
         [machine-search-panel
          {:is-active? (:machine-id @search-panel-active?)
           :header-props {:on-click #(swap! search-panel-active? assoc :machine-id (not (:machine-id @search-panel-active?)))}}]
         [machine-search-panel
          {:is-active? (:machine-type @search-panel-active?)
           :header-props {:on-click #(swap! search-panel-active? assoc :machine-type (not (:machine-type @search-panel-active?)))}}]
         [testing-scroll
          {:is-active? true}]]
        [:div
         "Machine type filter"
         [:input.input
          {:placeholder "hello"
           :value (:machine-type @search-variables)
           :on-change (fn [event] (swap! search-variables assoc :machine-type event.target.value))}]]
        [:div
         "Venue filter"
         [:input.input
          {:placeholder "hello"
           :value (:venue-id @search-variables)
           :on-change (fn [event] (swap! search-variables assoc :venue-id event.target.value))}]]
        [:div
         "Machine id filter"
         [:input.input
          {:placeholder "hello"
           :value (:machine-id @search-variables)
           :on-change (fn [event] (swap! search-variables assoc :machine-id event.target.value))}]]
        [:div
         "Oche id filter"
         [:input.input
          {:placeholder "hello"
           :value (:oche-id @search-variables)
           :on-change (fn [event] (swap! search-variables assoc :oche-id event.target.value))}]]
        [machine]
        [machines]
        [:i
         {:class (flag-icons/main {:country-code :no :flag-type "square"})
          :style {:font-size "5rem"}}]
        [tiles]
        [button/default
         {:on-click (fn [] (css/set-theme :light))}
         "Light theme"]
        [button/default
         {:on-click (fn [] (css/set-theme :dark))}
         "Dark Theme"]
        [button/default
         {:on-click (fn [] (css/set-theme :system))}
         "System theme"]
        [button/border
         {:disabled (not app-installable?)
          :on-click (fn []
                      (sw/install-prompt))}
         "Install App"]
        [:p.subtitle
         (str "Current theme: " theme)]
        [:p.subtitle
         (str "User selected theme: " user-selected-theme)]
        [:p.subtitle
         (str "System theme: " system-theme)]
        [:p.subtitle
         (str "Permission: " notification-permission?)]
        [:button.button.is-rounded
         {:class (if notification-permission? "is-success" "is-warning")
          :disabled (not notification-permission?)
          :on-click (fn [] (notification/create))}
         "Create notification"]
        [:p.subtitle
         (str @sw/messages)]
        [:button.button.is-rounded
         {:disabled notification-persistent?
          :on-click (fn [] (notification/close))}
         "Close notification"]
        [:p.subtitle
         (str "Display mode: " display-mode)]
        #_[:p.subtitle
           (str connection-information)]
        #_[:button.button.is-rounded
           {:on-click (fn []
                                        ;(.update @service-worker-registration) ;;If we for some reason want to make changes to the
                                        ; service-worker.js file and want that to be reflected immediately, we can make this call




                        (connection/update-information))}
           "Check connection"]
        #_[auto-hiccup-test]]]))
